<svelte:options runes={true} />

<script lang="ts">
  import type { FilterOption } from "~/lib/filters/types";
  import CheckboxGroup from "~/components/ui/CheckboxGroup/CheckboxGroup.svelte";
  import EmptyState from "~/components/ui/EmptyState/EmptyState.svelte";
  import Input from "~/components/ui/Input/Input.svelte";

  interface Props {
    options: FilterOption[];
    selectedValues?: string[];
    searchThreshold?: number;
    onChange?: (values: string[]) => void;
    class?: string;
  }

  let {
    options,
    selectedValues = [],
    searchThreshold = 6,
    onChange,
    class: className = "",
  }: Props = $props();

  let searchQuery = $state("");
  const showSearch = $derived(options.length > searchThreshold);
  const filteredOptions = $derived(
    searchQuery === ""
      ? options
      : options.filter((o) => o.label.toLowerCase().includes(searchQuery.toLowerCase())),
  );
</script>

<div class="da-filter-checkbox-list {className}" role="group">
  {#if showSearch}
    <Input
      variant="search"
      bind:value={searchQuery}
      aria-label="Search options"
      class="da-filter-checkbox-list__search"
    />
  {/if}
  {#if filteredOptions.length === 0}
    <EmptyState class="da-filter-checkbox-list__empty" />
  {:else}
    <CheckboxGroup
      options={filteredOptions}
      value={selectedValues}
      {onChange}
      class="da-filter-checkbox-list__group"
    />
  {/if}
</div>

<style>
  @layer aurora {
    .da-filter-checkbox-list {
      display: flex;
      flex-direction: column;
      gap: var(--da-space-2);
    }
  }
</style>
